export default __webpack_public_path__ + "static/columnResizing-23e7c472d64f157330de55a014f987f4.gif";